import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getHBXChannelHotelActive(hotel) {
  const {
    host,
    URIs: { hbxChannelHotelActive },
  } = apiConfig;

  const uri = `${host}${hbxChannelHotelActive}`.replace(':hotelId', hotel);

  return await axios.get(uri).then(res => res.data);
}
